import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/black_id_film.svg")